import * as React from 'react'
import { ReactElement, useContext } from 'react'
import { Button, DrawerBody, DrawerHeader, DrawerHeaderTitle, mergeClasses, OverlayDrawer, Text } from '@fluentui/react-components'
import { isOfficeInitialized } from '../helpers/outlookHelper'
import { useTranslation } from 'react-i18next'
import useUser from '../hooks/useUser'
import AuthorizationContext from '../context/AuthorizationContext'
import { useApplicationStyles } from '../pages/App'
import BaseCombobox from './Combobox/BaseCombobox'

type Props = {
    isOpen: boolean
    setIsOpen: (isOpen: boolean) => void
}

export default function MainOverlayDrawer(props: Props): ReactElement {
    const appStyles = useApplicationStyles()
    const { t: translate } = useTranslation()
    const { currentUser } = useUser()
    const { setHost, host, hosts, reset } = useContext(AuthorizationContext)

    return (
        <OverlayDrawer as={'aside'} position={'end'} open={props.isOpen} onOpenChange={(_, { open }) => props.setIsOpen(open)}>
            <DrawerHeader>
                <DrawerHeaderTitle>{currentUser?.fullName}</DrawerHeaderTitle>
            </DrawerHeader>
            <DrawerBody className={mergeClasses(appStyles.flexColumn, appStyles.gapS)}>
                {hosts.length > 1 && (
                    <>
                        <Text>{translate('menu.host.label')}</Text>
                        <BaseCombobox
                            required
                            tabIndex={-1}
                            placeholderKey={'menu.host.placeholder'}
                            entities={hosts}
                            selectedOptions={[host?.RowKey]}
                            getEntityValue={entity => entity.RowKey}
                            getEntityLabel={entity => entity.Name}
                            onOptionSelect={(_e, _data, selectedEntities) => setHost(selectedEntities?.[0])}
                        />
                    </>
                )}
                {!isOfficeInitialized() && (
                    <>
                        <Text>&nbsp;</Text>
                        <Button
                            appearance={'primary'}
                            // iconProps={{ iconName: 'Leave' }}
                            onClick={() => {
                                if (isOfficeInitialized()) {
                                    setHost(undefined)
                                } else {
                                    reset()
                                }
                            }}
                        >
                            {translate('menu.logout')}
                        </Button>
                    </>
                )}
            </DrawerBody>
        </OverlayDrawer>
    )
}
